import React from 'react';

import PageLayout from '../../../components/PageLayout';

import Terms from './Terms';

async function action() {
  return {
    title: 'Terms',
    description:
      'These are the terms and conditions that pertain the use of our website.',
    chunks: ['terms'],
    component: (
      <PageLayout>
        <Terms key="terms" />
      </PageLayout>
    ),
  };
}

export default action;
